module.exports = [
    {
      name:"首页",
      path:"/",
      icon:"el-icon-s-home",
    },
    {
      name:"用户管理",
      path:"/user",
      icon:"el-icon-user-solid",
      permission:{module:"user"},
    },
    {
      name:"角色管理",
      path:"/role",
      icon:"el-icon-help",
      permission:{module:"role"},
    },
    {
      name:"问题管理",
      path:"/question",
      icon:"el-icon-question",
      permission:{module:"question"},
    },
    {
      name:"症状管理",
      path:"/symptom",
      icon:"el-icon-s-release",
      permission:{module:"symptom"},
    },
    {
      name:"诊断结果管理",
      path:"/consultate",
      icon:"el-icon-s-finance",
      permission:{module:"consultate"},
    },
    {
      name:"课堂管理",
      path:"/article",
      icon:"el-icon-s-finance",
      permission:{module:"article"},
    },
    {
      name:"鹦鹉管理",
      path:"/birds",
      icon:"el-icon-s-finance",
      permission:{module:"birds"},
    },
    {
      name:"图库管理",
      path:"/photo",
      icon:"el-icon-s-finance",
      permission:{module:"photo"},
    },
]


// WEBPACK FOOTER //
// ./src/config/menu.js